import * as z from 'zod';


export const packingListSchemaForDetails = z.object({
    id: z.string().optional().nullable(),
    packingListId: z.string().optional().nullable(),
    packingListDate: z.union([z.string(), z.date()]).optional().nullable(),
    orderId: z.string().optional().nullable(),
    batchId: z.string().optional().nullable(),
    qualityId: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    orderedProductId: z.string().optional().nullable(),
    supplierId: z.string().optional().nullable(),
    packingListType: z.string().optional().nullable(),
    packingListState: z.number()

})

export const packingListSchema = z.object({
    packingListId: z.string().optional().nullable(),
    packingListDate: z.union([z.string(), z.date()]).optional().nullable(),
    orderId: z.string().optional().nullable(),
    rollIds: z.array(z.string()).optional().nullable(),
    orderedProductId: z.string().optional().nullable(),

})